(function () {
  if (window.__bannerReveal) return;
  window.__bannerReveal = true;

  /* 75% from the bottom of the viewport = 25% from the top. */
  var TRIGGER_START = 0.25;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function clamp(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  function progressFor(section) {
    if (prefersReducedMotion()) return 1;

    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var start = vh * TRIGGER_START;
    var range = start;
    if (range <= 0) return 1;

    return clamp((start - rect.top) / range);
  }

  function update() {
    ticking = false;
    document.querySelectorAll('[data-banner-reveal]').forEach(function (el) {
      var section = el.closest('[data-banner]');
      if (!section || !el.hasAttribute('data-banner-collapsed')) return;
      section.style.setProperty('--banner-progress', String(progressFor(section)));
    });
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function refresh() {
    var canScrub = !prefersReducedMotion() && typeof window.requestAnimationFrame === 'function';

    document.querySelectorAll('[data-banner-reveal]').forEach(function (el) {
      var section = el.closest('[data-banner]');
      if (!canScrub) {
        el.removeAttribute('data-banner-collapsed');
        el.classList.remove('is-expanded', 'is-revealed');
        if (section) section.style.removeProperty('--banner-progress');
        return;
      }
      el.setAttribute('data-banner-collapsed', '');
      el.classList.remove('is-expanded', 'is-revealed');
    });

    update();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', refresh);
  document.addEventListener('shopify:section:reorder', refresh);

  if (reducedMotion.addEventListener) {
    reducedMotion.addEventListener('change', refresh);
  } else if (reducedMotion.addListener) {
    reducedMotion.addListener(refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
